// [TRASH-SEEN] Per-browser "seen" state for the Trash drawer.
//
// The trash badge counts soft-deleted rows (refunds/disputes/inventory). Once an
// admin has reviewed the trash they want the badge to clear so it stops reading
// as "pending work" — but it must re-appear when something NEW is deleted, or the
// feature would silently stop surfacing deletions. So instead of a dumb "hide the
// number" flag, we remember WHICH deleted rows were acknowledged (by their
// `source-id` key). The header badge then shows the count of rows that are in the
// trash but NOT yet acknowledged — exactly the email-style "unread" model.
//
// Stored in localStorage: it's a per-user, per-browser convenience (like the
// theme toggle), not shared state, so it needs no backend table or deploy.

const KEY = 'dt-trash-seen';

/** Read the set of acknowledged trash keys. Tolerant of missing/corrupt data. */
export function loadTrashSeen(): Set<string> {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return new Set();
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? new Set(arr.filter((x) => typeof x === 'string')) : new Set();
  } catch {
    return new Set();
  }
}

/** Persist the acknowledged trash keys. No-op if localStorage is unavailable. */
export function saveTrashSeen(keys: Set<string>): void {
  try {
    localStorage.setItem(KEY, JSON.stringify([...keys]));
  } catch {
    /* private mode / quota exceeded — non-fatal, badge just won't persist */
  }
}
